export default "__VITE_ASSET__e0392e74__"